import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { ItemEntity } from './item.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_item__id', ['fkItemId'], {})
@Index('idx_item__file_inheritedFrom', ['fkItemFileIdInheritedFrom'], {})
@Entity('item__file')
export class ItemFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_item__id', unsigned: true })
	public fkItemId!: number;

	// Set when this row is an inherited copy of the parent item's file
	// attachment (PD-16509): the parent's item__file row it mirrors. NULL for
	// the item's own files.
	@Column('int', {
		name: 'fk_item__file__id_inheritedFrom',
		nullable: true,
		unsigned: true,
	})
	public fkItemFileIdInheritedFrom!: number | null;

	@ManyToOne(() => FileEntity, (file) => file.itemFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(() => ItemEntity, (item) => item.itemFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;
}
